import React from "react"

type PublicRouteProps = {
    children: React.ReactElement
}

const PublicRoute = ({children}: PublicRouteProps) => {
    return children
}

export default PublicRoute